<template>
    <div>
        <el-dialog
            :title="title"
            :visible.sync="showDialog"
            fullscreen
            :show-close="false"
            :close-on-press-escape="false">

            <el-row :gutter="20">
                <el-col :span="8" v-for="permission in permissions" :key="permission.id">
                    <el-card style="margin-bottom: 2%">
                        <el-tree
                            :data="permission.data"
                            :props="defaultProps"
                            ref="tree"
                            node-key="id"
                            show-checkbox>
                        </el-tree>
                    </el-card>
                </el-col>
            </el-row>
            <el-row :gutter="20" v-if="system == 3">
                <Docs :userId="userId" :requirements="requirements">
                    <div slot="main">
                        Documentos agregados hasta el momento.
                    </div>
                </Docs>
            </el-row>
            <span slot="footer" class="dialog-footer">
                <el-button @click="$emit('close-dialog')">Cancelar</el-button>
                <el-button type="primary" @click="submitPermissionsBy(system)">Aceptar</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import Docs from '@/components/partials/Docs';
    import {mapState, mapGetters, mapActions, mapMutations} from 'vuex';
    import eFirma from "./eFirma";

    export default {
        components: {
            Docs,
            eFirma
        },
        computed: {
            ...mapGetters('utils', {
                userRequest: "userRequest",
            }),
            userInfo() {
                return this.$store.state.user.user;
            },
        },
        props: {
            title: {
                type: String,
                required: true
            },

            showDialog: {
                type: Boolean,
                required: true,
                default: false
            },

            system: {
                type: Number,
                required: true,
            },

            userRoles: {
                type: Array,
                required: false
            },

            userId: {}
        },

        created() {
            let _userId = this.$route.params.id ? this.$route.params.id : this.userInfo.hash_id;
            axios.get('/api/get-requirements',{params: {profile: _userId}}).then(response => {
                if(response.data.success){
                    this.requirements = response.data.requirements[0]
                }
            })
        },


        watch: {
            showDialog() {

                if (this.showDialog === true) {
                    this.getPermissionsBy(this.system, this.userRoles);
                }
            }
        },

        data() {
            return {

                permissions: [],

                defaultProps: {
                    children: 'children',
                    label: 'label'
                },
                requirements: []
            }
        },

        methods: {
            showLoading() {
                this.$store.dispatch('loading/spinner',
                    {msg: 'Cargando Datos...', status: true}, {root: true});
            },
            hideLoading() {
                this.$store.dispatch('loading/spinner', {}, {root: true});
            },

            getPermissionsBy(system, userRoles) {

                this.permissions = [];
                this.showLoading();

                axios.post('/api/users/permissions', {system}).then(response => {

                    this.distributeRolesBy(response.data.roles, this.isInteger(response.data.roles));

                    if (userRoles && userRoles.length > 0) {
                        this.$nextTick(function () {
                            for (let i = 0; i < this.$refs.tree?.length; i++) {
                                this.$refs.tree[i].setCheckedKeys(this.userRoles);
                            }
                        });
                    }
                    this.hideLoading();
                }).catch(error => {
                    console.log('getPermissionsBy', error);
                    this.hideLoading();

                    this.$notify({
                        type: 'error',
                        message: 'No se pudo completar la acción'
                    });
                });
            },

            distributeRolesBy(roles, modules) {

                for (let i = 0; i < modules.length; i++) {
                    let tree = [];

                    _.forEach(roles, function (rol) {
                        if (rol.level === modules[i]) {
                            tree.push({
                                id: rol.id,
                                label: rol.description,
                                children: [],
                            });
                        }

                        if (rol.level > modules[i] && rol.level < modules[i] + 1) {
                            tree[0].children.push({
                                id: rol.id,
                                label: rol.description,
                            });
                        }
                    });

                    this.permissions.push({data: tree});
                }
            },

            isInteger(roles) {

                let modules = [];

                _.forEach(roles, function (rol) {
                    if (rol.level % 1 === 0) {
                        modules.push(rol.level);
                    }
                });
                return modules;
            },

            submitPermissionsBy(system) {
                let permissions = [];
                let userForm = [];

                if (this.$refs.tree && this.$refs.tree?.length > 0) {
                    for (let i = 0; i < this.$refs.tree.length; i++) {
                        if (this.$refs.tree[i].getCheckedKeys()) {
                            permissions.push(this.$refs.tree[i].getCheckedKeys());
                        }
                        userForm = permissions.concat();
                    }
                }


                userForm = [].concat.apply([], permissions);
                this.$emit('save-permissions', system, userForm);
                this.$emit('close-dialog');
            }
        },
    }
</script>
<style scoped>

</style>
